import { IframeHeader } from "./IframeHeader";
import { IframeLoading } from "./Loadings";

export const IframePanel = ({
  header: { title, onClick, className, isLoading, loadingLabel, btnLabel, Icon },
  frameRef,
  frameLoaded,
  iframeHeight,
  iframeWidth,
  dataFrame,
}: {
  header: {
    title: string;
    onClick: () => void;
    className: string;
    isLoading: boolean;
    loadingLabel: string;
    btnLabel: string;
    Icon: React.FC<any>;
  };
  frameRef: React.RefObject<HTMLIFrameElement>;
  frameLoaded: boolean;
  iframeHeight: number;
  iframeWidth: number;
  dataFrame: string;
}) => (
  <div className="flex flex-col overflow-hidden rounded-lg bg-green-50 dark:bg-gray-900">
    <IframeHeader
      title={title}
      onClick={onClick}
      className={className}
      isLoading={isLoading}
      loadingLabel={loadingLabel}
      btnLabel={btnLabel}
      Icon={Icon}
    />
    <div
      className="relative flex-1 overflow-auto"
      style={{ height: `${iframeHeight}px` }}
      data-frame={dataFrame}
    >
      {!frameLoaded && <IframeLoading />}
      <iframe
        ref={frameRef}
        title={title}
        src={`/artboard/preview?width=${iframeWidth}&frameId=${dataFrame}`}
        className="w-full border-0"
        style={{ height: `${iframeHeight}px`, backgroundColor: "white" }}
      />
    </div>
    <IframeHeader
      title={title}
      onClick={onClick}
      className={className}
      isLoading={isLoading}
      loadingLabel={loadingLabel}
      btnLabel={btnLabel}
      Icon={Icon}
    />
  </div>
);
